import { useCallback, useMemo } from 'react';
import { useLocation } from '@reach/router';

import { getStorage } from '~/src/common/storage';
import { navigate } from '~/src/common/utilities';

import { RedirectionAfterPasswordReset } from './RedirectionAfterPasswordReset';
import { AFTER_PASSWORD_RESET_SIGN_UP_REDIRECT_URL_STORAGE_KEY } from './storage-keys';

export function useMaybeRedirectAfterPasswordReset() {
  const storage = getStorage();
  const { pathname } = useLocation();

  const afterPasswordResetRedirectUrl = storage.getItem(
    AFTER_PASSWORD_RESET_SIGN_UP_REDIRECT_URL_STORAGE_KEY,
  );

  const redirectAfterSignIn = useMemo(
    () =>
      new RedirectionAfterPasswordReset({
        afterPasswordResetRedirectUrl,
      }),
    [afterPasswordResetRedirectUrl],
  );

  const maybeRedirect = useCallback(() => {
    if (redirectAfterSignIn.canRedirect()) {
      navigate(redirectAfterSignIn.getRedirectUrl());
      storage.removeItem(AFTER_PASSWORD_RESET_SIGN_UP_REDIRECT_URL_STORAGE_KEY);
    }
  }, [redirectAfterSignIn, storage]);

  const planToRedirectToCurrentPageAfterPasswordReset = useCallback(() => {
    if (RedirectionAfterPasswordReset.isPathInWhiteList(pathname)) {
      storage.setItem(AFTER_PASSWORD_RESET_SIGN_UP_REDIRECT_URL_STORAGE_KEY, pathname);
    }
  }, [pathname, storage]);

  return { maybeRedirect, planToRedirectToCurrentPageAfterPasswordReset };
}
